/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_OverlineInputs */

const en_mk_ctrl_overline = /** @type {(inputs: Mk_Ctrl_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTROL TOWER`)
};

const id_mk_ctrl_overline = /** @type {(inputs: Mk_Ctrl_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MENARA KENDALI`)
};

/**
* | output |
* | --- |
* | "CONTROL TOWER" |
*
* @param {Mk_Ctrl_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_overline = /** @type {((inputs?: Mk_Ctrl_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_overline(inputs)
	return en_mk_ctrl_overline(inputs)
});